import {
  Card,
  CardBody,
  FunctionCard,
  Image,
  Paragraph,
  Separator,
  useMatchMediaTierProp,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import { useOfferData } from "../../app/hooks"
import { useOfferScreenFlow } from "../../hooks/useOfferScreenFlow"
import OfferInfoComponent from "./OfferInfoPage"
import { OfferNavButtons } from "./OfferNavButtons"

const IMAGE_URL = "./assets/error.png"

const OfferEvaluationFailed = () => {
  const { t } = useTranslation()
  const offerData = useOfferData()
  const { setNextStep } = useOfferScreenFlow()

  const headerTitle = t("offers.evaluation.titleFinished")

  const textContent = (
    <>
      <Paragraph
        style={{
          marginBottom: "2rem",
        }}
      >
        {t("offers.evaluation.text.failed")}
      </Paragraph>
      <Paragraph>{t("offers.evaluation.text.failed2")}</Paragraph>
    </>
  )

  const nextButtonHandler = () => {
    setNextStep(offerData?.caseId)
  }

  const navButtonsContent = (
    <OfferNavButtons
      nextButtonText={t("offers.button.close2")}
      onNextButtonClicked={nextButtonHandler}
    />
  )

  const pageContent = useMatchMediaTierProp({
    xs: (
      <OfferInfoComponent
        buttonText={t("offers.button.close2")}
        headerText={headerTitle}
        imageUrl={IMAGE_URL}
        onButtonClicked={nextButtonHandler}
        textContent={textContent}
      />
    ),
    md: (
      <Card nested={false}>
        <FunctionCard
          padding={Card.PADDING.LARGE}
          heading={headerTitle}
          indicator={<Image src={IMAGE_URL} alt="" />}
        >
          {textContent}
        </FunctionCard>

        <Separator />

        <CardBody>{navButtonsContent}</CardBody>
      </Card>
    ),
  })

  return <>{pageContent}</>
}

export default OfferEvaluationFailed
